import React, { StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <StrictMode>
      <Suspense fallback={<div></div>}>
    <BrowserRouter basename='/'>
      <App />
    </BrowserRouter>
      </Suspense>
    </StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <Suspense fallback={<div></div>}>
         <BrowserRouter basename='/'>
      <App />
    </BrowserRouter>
      </Suspense>
    </StrictMode>
  );
}
